export const STORE_LOGIN_REQUEST = "STORE_LOGIN_REQUEST";
export const STORE_LOGIN_SUCCESS = "STORE_LOGIN_SUCCESS";
export const STORE_LOGIN_FAIL = "STORE_LOGIN_FAIL";
export const STORE_LOGOUT_REQUEST = "STORE_LOGOUT_REQUEST";
export const STORE_LOGIN_RESET = "STORE_LOGIN_RESET";

export const STORE_SIGNUP_REQUEST = "STORE_SIGNUP_REQUEST";
export const STORE_SIGNUP_SUCCESS = "STORE_SIGNUP_SUCCESS";
export const STORE_SIGNUP_FAIL = "STORE_SIGNUP_FAIL";
